import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import ScanResultView from "@/components/ScanResultView";

export default function PublicScan() {
  const [scan, setScan] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const raw = sessionStorage.getItem("guest_scan");
    if (!raw) {
      navigate("/", { replace: true });
      return;
    }
    try {
      setScan(JSON.parse(raw));
    } catch {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  if (!scan) {
    return (
      <div className="min-h-[calc(100vh-3.5rem)] bg-white flex items-center justify-center text-[#9B9A97] text-sm" data-testid="public-scan-loading">
        Loading your scan…
      </div>
    );
  }

  return (
    <>
      <div className="max-w-5xl mx-auto px-6 pt-6">
        <Link to="/" data-testid="public-back-link" className="text-sm text-[#787774] hover:text-[#37352F]">← Run another scan</Link>
      </div>
      <ScanResultView scan={scan} showGuestBanner={true} />
    </>
  );
}
